import {defineStore} from 'pinia'

// @ts-ignore
export const useAdminCommonStore = defineStore('admin-common', {
  state: () => ({
    pathPrefix: '/admin/common'
  }),
  getters: {},
  actions: {
    /**
     * 시스템 코드 추가
     * @param payload
     * @returns {Promise<*>}
     */
    async postSystemCode(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/system-code`
      return await $apiClient(path, {
        method: 'POST',
        body: {parentCode: payload.parentCode, code: payload.code, codeName: payload.codeName}
      })
    },
    /**
     * 시스템 코드 리스트 조회
     * @param payload
     * @returns {Promise<*>}
     */
    async getSystemCodeList(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/system-code/${payload.parentCode}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 알림 리스트 조회
     * @param payload
     * @returns {Promise<*>}
     */
    async getNotificationList(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/notification`
      const query = `?type=${payload.type}`
      return await $apiClient(`${path}${query}`, {
        method: 'GET'
      })
    },
    /**
     * 알림 읽음 처리
     * @param payload
     * @returns {Promise<*>}
     */
    async putNotification(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/notification/${payload.notificationId}`
      return await $apiClient(path, {
        method: 'PUT'
      })
    },
    async putPreSignInfoFile(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/pre-sign/information/file`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload
      })
    },
    /**
     * 시스템 코드 수정
     * @param payload
     * @returns {Promise<*>}
     */
    async putSystemCode(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/system-code`
      return await $apiClient(path, {
        method: 'PUT',
        body: {parentCode: payload.parentCode, code: payload.code, codeName: payload.codeName}
      })
    },
    /**
     * 공지사항 등록
     * @param payload
     * @returns {Promise<*>}
     */
    async postNotice(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/notice`
      return await $apiClient(path, {
        method: 'POST',
        body: {title: payload.title, content: payload.content}
      })
    },
    /**
     * 자주묻는질문 등록
     * @param payload
     * @returns {Promise<*>}
     */
    async postFaq(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/faq`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    /**
     * 주소정보 조회
     * @returns {Promise<*>}
     */
    async getAddressInfo(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/address?address=${payload}`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 회사 주소 수정
     * @param payload
     * @returns {Promise<*>}
     */
    async putAddressInfo(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/address`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload
      })
    },
    /**
     * 공지사항 수정
     * @param payload
     * @returns {Promise<*>}
     */
    async putNotice(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/notice/${payload.noticeId}`
      return await $apiClient(path, {
        method: 'PUT',
        body: {title: payload.title, content: payload.content}
      })
    },
    /**
     * 자주묻는질문 수정
     * @param payload
     * @returns {Promise<*>}
     */
    async putFaq(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/faq/${payload.faqId}`
      return await $apiClient(path, {
        method: 'PUT',
        body: {type: payload.type, title: payload.title, content: payload.content}
      })
    },
    /**
     * 공지사항 삭제
     * @param payload
     * @returns {Promise<*>}
     */
    async deleteNotice(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/notice/${payload}`
      return await $apiClient(path, {
        method: 'DELETE'
      })
    },
    /**
     * 자주묻는질문 삭제
     * @param payload
     * @returns {Promise<*>}
     */
    async deleteFaq(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/faq/${payload}`
      return await $apiClient(path, {
        method: 'DELETE'
      })
    },
    /**
     * 메인페이지 관리 조회
     */
    async getMainLandingInfo() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/main`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 메인페이지 광고 등록
     * @param payload
     * @returns {Promise<*>}
     */
    async postAdvertise(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/main/advertise`
      return await $apiClient(path, {
        method: 'POST',
        body: {type: payload.type, keys: payload.keys}
      })
    },
    /**
     * 메인페이지 이미지 수정
     * @param payload
     * @returns {Promise<*>}
     */
    async putPreSignMainLandingInfo(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/pre-sign/main`
      return await $apiClient(path, {
        method: 'PUT',
        body: {type: payload.type, targetId: payload.targetId, keys: payload.keys}
      })
    },
    /**
     * 메인페이지 배너 수정
     * @param payload
     * @returns {Promise<*>}
     */
    async putMainLandingBanner(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/main/banner/${payload.bannerId}`
      return await $apiClient(path, {
        method: 'PUT',
        body: {seminarId: payload.seminarId}
      })
    },
    /**
     * 메인페이지 광고 수정
     * @param payload
     * @returns {Promise<*>}
     */
    async putAdvertise(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/main/advertise/${payload.advertiseId}`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload
      })
    },
    /**
     * 메인페이지 광고 삭제
     * @param payload
     * @returns {Promise<*>}
     */
    async deleteAdvertise(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/main/advertise/${payload.advertiseId}`
      return await $apiClient(path, {
        method: 'DELETE'
      })
    },
    /**
     * 문자발송
     * @param payload
     * @returns {Promise<*>}
     */
    async postSms(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/sms`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    /**
     * 문자 대량발송
     * @param payload
     * @returns {Promise<*>}
     */
    async postBulkSms(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/sms/bulk`
      return await $apiClient(path, {
        method: 'POST',
        body: {phoneList: payload.phoneList, content: payload.content}
      })
    },
    /**
     * 최근 발송 문자 내용 불러오기
     * @returns {Promise<*>}
     */
    async getRecentSms() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/sms/recent`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 이메일발송
     * @param payload
     * @returns {Promise<*>}
     */
    async postEmail(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/email`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    /**
     * 이메일 대량발송
     * @param payload
     * @returns {Promise<*>}
     */
    async postBulkEmail(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/email/bulk`
      return await $apiClient(path, {
        method: 'POST',
        body: {emailList: payload.emailList, title: payload.title, content: payload.content}
      })
    },
    /**
     * 최근 발송 이메일 내용 불러오기
     * @returns {Promise<*>}
     */
    async getRecentEmail() {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/email/recent`
      return await $apiClient(path, {
        method: 'GET'
      })
    },
    /**
     * 이용약관 관련 정보 수정
     * @param payload
     * @returns {Promise<*>}
     */
    async putTermsInfo(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/terms`
      return await $apiClient(path, {
        method: 'PUT',
        body: {type: payload.type, title: payload.title, content: payload.content}
      })
    },
    /**
     * 에디터 작성글 수정
     * @param payload
     * @returns {Promise<*>}
     */
    async putEditorBoard(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/editor`
      return await $apiClient(path, {
        method: 'PUT',
        body: {type: payload.type, parentType: payload.parentType, content: payload.content}
      })
    },
    /**
     * 1:1 문의 댓글 등록
     * @param payload
     * @returns {Promise<*>}
     */
    async postQnaReply(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/qna/reply/${payload.qnaId}`
      return await $apiClient(path, {
        method: 'POST',
        body: payload
      })
    },
    /**
     * 1:1 문의 댓글 수정
     * @param payload
     * @returns {Promise<*>}
     */
    async putQnaReply(payload) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/qna/reply/${payload.replyId}`
      return await $apiClient(path, {
        method: 'PUT',
        body: payload
      })
    },
    /**
     * 1:1 문의 댓글 삭제
     * @param replyId
     * @returns {Promise<*>}
     */
    async deleteQnaReply(replyId) {
      const {$apiClient} = useNuxtApp()
      const path = `${this.pathPrefix}/qna/reply/${replyId}`
      return await $apiClient(path, {
        method: 'DELETE',
      })
    },
  }
})
